let $api_eap = {
  user: {
    delete: 'eap/user/delete.json',
    info: 'eap/user/info.json',
    list: 'eap/user/list.json',
    login: 'eap/user/login.json',
    logout: 'eap/user/logout.json',
    save: 'eap/user/save.json',
    search: 'eap/user/search.json',
    account: 'eap/user/check/account.json',
    template: 'eap/user/download/template.xls',
    upload: 'eap/user/upload.json',
    usersDown: 'eap/user/download/users.xls',
    getPipeiRenyuan: 'eap/contract/khList.json',
    leave: 'eap/user/leave.json', // 离职4.14增
    autocomplete: 'eap/user/autocomplete.json',
    seal: 'eap/user/searchby/seal.json', // 根据印章号查询人
    password: 'eap/user/password/update.json',
    logInToday: 'eap/user/logInToday.json',
    sevenLogInToday: 'eap/user/sevenLogInToday.json',
    statistical: 'eap/team/statistical.json', // 根据单位id统计人员登录情况，支持按周、月统计
    statisticalData: 'eap/statistical/index/search.json', // 查询每周登录人数
    statisticalSearch: '/eap/statistical/login/search.json', // 柱状图数据，每天登陆时间
    assignJobNumber: 'eap/user/assignJobNumber.json',
    autocompleteCheck: 'eap/user/autocompleteCheck.json',
    dingTalkAuth: 'pms/dingtalk/auth.json'
  },
  team: {
    delete: 'eap/team/delete.json',
    info: 'eap/team/info.json',
    list: 'eap/team/list.json',
    save: 'eap/team/save.json',
    search: 'eap/team/search.json',
    childrensearch: '/eap/team/search/children.json',
    tree: 'eap/team/tree.json',
    autocomplete: 'eap/team/autocomplete.json',
    principal: 'eap/team/searchuser.json',
    jobsearch: '/eap/job/title/search.json',
    jobdelete: '/eap/job/title/delete.json',
    jobsave: '/eap/job/title/save.json',
    jobinfo: '/eap/job/title/info.json'
  },
  role: {
    bindRole: 'eap/user/bind/role.json',
    menuSearchby: '/eap/user/searchby/role.json',
    searchbyRole: 'eap/role/searchby/user.json',
    bindMenu: 'eap/role/bind/menu.json',
    searchby: 'eap/menu/searchby/role.json',
    bindPermission: 'eap/role/bind/permission.json',
    bindUser: '/eap/role/bind/user.json',
    groupTree: 'eap/role/groupTree.json',
    delete: 'eap/role/delete.json',
    info: 'eap/role/info.json',
    list: 'eap/menu/role/list.json',
    save: 'eap/role/save.json',
    search: 'eap/role/search.json',
    tree: 'eap/role/tree.json',
    check: 'eap/role/name/check.json',
    gen: 'eap/role/name/gen.json',
    preBind: 'eap/role/preBind.json',
    eliminateModelTree: 'eap/kgr/category/eliminate/modeltree.json',
    modelTree: 'eap/kgr/category/modeltree.json',
    modelSave: 'eap/kgr/category/modelsave.json',
    modelDataSave: 'eap/kgr/category/eliminate/modelsave.json',
    modelButton: 'eap/kgr/category/model/button.json',
    userModel: 'eap/kgr/category/tree/user.json',
    modelUser: 'eap/kgr/category/tree/model.json',
    userModelBtn: 'eap/role/user/role.json',
    userModelTree: '/eap/kgr/category/role/modeltree.json'
  },
  activitiForm: {
    search: 'eap/activiti/form/search.json',
    save: 'eap/activiti/form/save.json',
    saveDesign: 'eap/activiti/form/design/save.json',
    delete: '/eap/activiti/form/delete.json',
    info: '/eap/activiti/form/info.json'
  },
  menu: {
    delete: 'eap/menu/delete.json',
    info: 'eap/menu/info.json',
    list: 'eap/menu/list.json',
    save: 'eap/menu/save.json',
    search: 'eap/menu/search.json',
    tree: 'eap/menu/tree.json',
    user: 'eap/menu/tree/user.json',
    roleTree: 'eap/menu/tree/role.json'
  },
  config: {
    delete: 'eap/config/delete.json',
    key: 'eap/config/getKey.json',
    info: 'eap/config/info.json',
    list: 'eap/config/list.json',
    save: 'eap/config/save.json',
    search: 'eap/config/search.json',
    tree: 'eap/config/tree.json'
  },
  dict: {
    delete: 'eap/dict/delete.json',
    info: 'eap/dict/info.json',
    list: 'eap/dict/list.json',
    save: 'eap/dict/save.json',
    search: 'eap/dict/search.json',
    tree: 'eap/dict/tree.json',
    get: 'eap/dict/get.json',
    children: '/eap/dict/children.json',
    code: 'eap/dict/code.json',
    cityChildren: '/eap/city/children.json',
    city: '/eap/city/top.json',
    exam: 'eap/dict/exam.json'
  },
  bizTqdTestresult: {
    search: '/eap/bizTqdTestresult/search.json',
    save: '/eap/bizTqdTestresult/save.json',
    info: '/eap/bizTqdTestresult/info.json',
    delete: '/eap/bizTqdTestresult/delete.json'
  },
  bizGyfxyTestresult: {
    search: '/eap/bizGyfxyTestresult/search.json',
    save: '/eap/bizGyfxyTestresult/save.json',
    info: '/eap/bizGyfxyTestresult/info.json',
    delete: '/eap/bizGyfxyTestresult/delete.json'
  },
  bizCryTestresult: {
    search: '/eap/bizCryTestresult/search.json',
    save: '/eap/bizCryTestresult/save.json',
    info: '/eap/bizCryTestresult/info.json',
    delete: '/eap/bizCryTestresult/delete.json'
  },
  bizClyTestresult: {
    search: '/eap/bizClyTestresult/search.json',
    save: '/eap/bizClyTestresult/save.json',
    info: '/eap/bizClyTestresult/info.json',
    delete: '/eap/bizClyTestresult/delete.json'
  },
  bizHrrxcsyTestresult: {
    search: '/eap/bizHrrxcsyTestresult/search.json',
    info: '/eap/bizHrrxcsyTestresult/info.json'
  },
  permission: {
    delete: 'eap/permission/delete.json',
    info: 'eap/permission/info.json',
    list: 'eap/permission/list.json',
    save: 'eap/permission/save.json',
    search: 'eap/permission/search.json',
    tree: 'eap/permission/tree.json',
    gen: 'eap/permission/gen.json'
  },
  job: {
    search: 'eap/job/search.json',
    delete: 'eap/job/delete.json',
    start: 'eap/job/start.json',
    stop: 'eap/job/stop.json',
    enable: 'eap/job/enable.json',
    disable: 'eap/job/disable.json',
    save: 'eap/job/save.json',
    info: 'eap/job/info.json',
    bean: 'eap/job/beans.json',
    searchDrawer: '/eap/job/log/search.json',
    run: '/eap/job/run.json'
  },
  log: {
    info: 'eap/log/info.json',
    search: 'eap/log/search.json'
  },
  eap: {
    model: 'eap/workflow/model/insert',
    list: '/eap/workflow/model/search.json',
    create: '/eap/workflow/model/create.json',
    deploy: '/eap/workflow/model/deploy.json',
    delete: '/eap/workflow/model/delete.json',
    workflow: '/eap/workflow/model/list.json',
    // 我申请的
    myapplyList: '/eap/workflow/model/myapplyList.json',
    // 我发布的
    myprocessList: '/eap/workflow/model/myprocessList.json',
    // 设计流程导出XML
    xmlExport: '/eap/workflow/model/export.json',
    // 流程模型导入XML
    xmlImport: '/eap/workflow/model/import.json'
  },
  device: {
    delete: '/eap/device/delete.json',
    info: '/eap/device/info.json',
    save: '/eap/device/save.json',
    search: '/eap/device/search.json',
    upload: '/eap/device/upload.json',
    template: '/eap/device/download/template.xls',
    list: '/eap/device/list.json',
    startprocess: '/eap/device/startprocess.json',
    showchoiceProcess: '/eap/device/showchoiceProcess.json',
    devicechoiceProcess: '/eap/device/devicechoiceProcess.json',
    choiceProcess: '/eap/order/choiceProcess.json',
    initstart: '/eap/order/initstart.json',
    initstartnew: '/eap/device/initstart.json',
    deviceinitstart: '/eap/device/deviceinitstart.json',
    download: '/eap/device/download/devices.xls'
  },
  contract: {
    search: '/eap/contract/search.json',
    delete: '/eap/contract/delete.json',
    info: '/eap/contract/info.json',
    save: '/eap/contract/save.json'
  },
  skill: {
    delete: '/eap/skill/delete.json',
    template: '/eap/skill/download/template.xls',
    info: '/eap/skill/info.json',
    save: '/eap/skill/save.json',
    allSave: 'eap/check/method/all/save.json',
    search: '/eap/skill/search.json',
    upload: '/eap/skill/upload.json'
  },
  customer: {
    search: '/eap/customer/search.json',
    delete: '/eap/customer/delete.json',
    info: '/eap/customer/info.json',
    save: '/eap/customer/save.json'
  },
  minio: {
    list: '/eap/minio/dir/list.json',
    make: '/eap/minio/dir/make.json',
    remove: '/eap/minio/dir/remove.json',
    download: '/eap/minio/file/download.json',
    fileList: '/eap/minio/file/list.json',
    removeFile: '/eap/minio/file/remove.json',
    upload: 'eap/minio/file/upload.json',
    fileDownload: 'eap/minio/file/bystream/download.json'
  },
  clsn: {
    delete: '/eap/js/clsn/delete.json',
    info: '/eap/js/clsn/info.json',
    save: '/eap/js/clsn/save.json',
    search: '/eap/js/clsn/search.json',
    clsnSelectList: '/eap/js/clsn/clsnSelectList.json'
  },
  bthzkyp: {
    delete: '/eap/js/bthzkyp/delete.json',
    info: '/eap/js/bthzkyp/info.json',
    save: '/eap/js/bthzkyp/save.json',
    search: '/eap/js/bthzkyp/search.json',
    selectList: '/eap/js/bthzkyp/selectList.json'
  },
  lhgf: {
    delete: '/eap/js/dhgf/delete.json',
    info: '/eap/js/dhgf/info.json',
    save: '/eap/js/dhgf/save.json',
    search: '/eap/js/dhgf/search.json',
    dhgfSelectList: '/eap/js/dhgf/dhgfSelectList.json'
  },
  processForm: {
    save: '/eap/processForm/save.json'
  },
  workflow: {
    mydonetask: '/eap/workflow/model/mydonetasklist.json',
    mytask: '/eap/workflow/model/dotasklist.json',
    viewDeatail: '/eap/workflow/model/viewDeatail.json',
    myInformation: '/eap/workflow/model/myInformation.json',
    dotask: '/eap/workflow/model/dotask.json',
    showDiagram: '/eap/workflow/model/showDiagram.json',
    putBackTask: '/eap/workflow/model/putBackTask.json',
    showTasklist: '/eap/workflow/model/showTasklist.json',
    settingForm: '/eap/workflow/model/settingForm.json',
    hisComment: 'eap/workflow/model/hisComment.json',
    putBackFirstTask: 'eap/workflow/model/putBackFirstTask.json'
  },
  category: {
    clear: '/eap/kgr/category/cache/clear.json'
  },
  eapSamplingRecord: {
    delete: '/eap/sampling/delete.json',
    info: '/eap/sampling/info.json',
    save: '/eap/sampling/save.json',
    search: '/eap/sampling/search.json'
  },
  index: {
    num: '/eap/index/num.json'
  },
  kgrStand: {
    tree: 'eap/kgrStandFreq/tree.json',
    search: 'eap/kgrStand/search.json',
    delete: 'eap/kgrStand/delete.json',
    info: 'eap/kgrStand/info.json',
    save: 'eap/kgrStand/save.json',
    textData: 'eap/kgrStand/searchby/dataId.json'
  },
  kgrcostdata: {
    search: 'eap/kgrcostdata/search/data.json'
  },
  eapReportFile: {
    search: 'eap/eapReportFile/search.json',
    delete: 'eap/eapReportFile/delete.json',
    tree: 'eap/eapReportFile/tree.json',
    save: 'eap/eapReportFile/save.json',
    info: 'eap/eapReportFile/info.json',
    fileName: 'eap/eapReportFile/by/moduleId/name.json',
    threeTree: 'eap/eapReportFile/get/tree.json',
    list: 'eap/eapReportFile/list.json',
    bind: 'eap/eapReportFile/bind.json',
    unbind: 'eap/eapReportFile/dismiss.json',
    unbindAll: 'eap/eapReportFile/many/dismiss.json',
    config: 'eap/eapReportFile/file/bind/name.json',
    fileType: 'eap/eapReportFile/file/type/name.json'
  },
  push: {
    groupSearch: 'eap/push/group/search.json',
    groupDelete: 'eap/push/group/delete.json',
    groupSave: 'eap/push/group/save.json',
    groupInfo: 'eap/push/group/info.json',
    memberSearch: 'eap/push/group/member/search.json',
    memberDelete: 'eap/push/group/member/delete.json',
    memberSave: 'eap/push/group/member/save.json',
    memberBind: 'eap/push/group/member/bind.json'
  },
  kgrItemDef: {
    search: 'eap/kgrItemDef/search.json',
    info: 'eap/kgrItemDef/info.json',
    delete: 'eap/kgrItemDef/delete.json',
    save: 'eap/kgrItemDef/save.json',
  },
  eapSql: {
    update: 'eap/eapReportFile/sql/update.json'
  }
};
export default $api_eap;
